module.exports = __webpack_public_path__ + "prod/1.2.3/img/check-circle-fill.3e26e6d2.svg";